import * as types from "../constants";

const initialState = {
  isLoading: true,
  error: null,
  items: [],
  filters: {},
  appliedFilters: {},
  showFilters: true,
};

export default function distributionMatrixFiltersReducer(
  state = initialState,
  action
) {
  switch (action.type) {
    case types.GET_DISTRIBUTION_MATRIX_FILTERS_INIT:
      return { ...state, error: null, isLoading: true };

    case types.GET_DISTRIBUTION_MATRIX_FILTERS_SUCCESS:
      return { ...state, isLoading: false, items: action.data.data };

    case types.GET_DISTRIBUTION_MATRIX_FILTERS_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: action.notification.system_message,
      };

    case types.SET_DISTRIBUTION_MATRIX_FILTERS:
      return {
        ...state,
        filters: action.data,
      };

    case types.MATRIX_SHOW_FILTERS:
      return { ...state, showFilters: action.data };

    case types.SET_APPLIED_DISTRIBUTION_MATRIX_FILTERS:
      return {
        ...state,
        appliedFilters: action.data,
      };

    default:
      return state;
  }
}
